import * as $ from 'jquery';

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AirMasterService } from 'app/service/air-master.service';
import { AuditProgramAIRDTO } from 'app/model/audit-program-air-dto';
import { AuditProgramAIRItemDocumentDTO } from 'app/model/audit-program-air-item-document-dto';
import { ComboPopulation } from 'app/model/combo-population';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { CustomMessages, EasyDialog } from '@shared';
import { FileDragDropComponent } from '@shared/components/file-drag/file-drag-drop.component';
import { HttpClient } from '@angular/common/http';
import { ManageAuditProgarmService } from 'app/service/manage-audit-progarm-service';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { environment } from '@env/environment';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { MatTableDataSource } from '@angular/material/table';
import { AuditAirLogBean } from 'app/model/audit-air-log-bean';
import { LoaderComponent } from 'app/theme/loader/loader.component';
import { MatChipInputEvent } from '@angular/material/chips';
import { UrlConfigService } from 'app/service/url-config.service';

@Component({
  selector: 'app-add-airitems',
  templateUrl: './add-airitems.component.html',
  styleUrls: ['./add-airitems.component.scss', '../../../../theme/loader/loader.component.scss'],
  providers: [TranslatePipe],
})
export class AddAIRItemsComponent implements OnInit {
  displayedColumns: string[] = [
    'id',
    'actionTakenBy',
    'action',
    'remarks',
    'lastModifiedBy',
    'lastModifiedOn',
  ];
  dataSource = new MatTableDataSource();
  ELEMENT_DATA: any = [];
  downloadDataList: any;

  //Document_Description Code line--50
  displayedColumns1: string[] = ['id', 'name1', 'action'];

  dataSource1 = new MatTableDataSource();
  ELEMENT_DATA1: any = [];
  parsedJson1: any;
  airaAditeeActioncStandardRepoList: any;
  dummyData: any = [
    { position: 1, name: 'Hydrogen' },
    { position: 2, name: 'Helium' },
    { position: 3, name: 'Lithium' },
    { position: 4, name: 'Beryllium' },
    { position: 5, name: 'Boron' },
  ];
  maxUploadSizeInMb: number = environment.MAX_UPLOAD_SIZE_IN_MB;
  fileExtnNotAllowedToUpload: string = environment.FILE_EXTN_NOT_ALLOWED_TO_UPLOAD;
  currentFile: File;
  selectedFiles: FileList;
  fileArray: File[] = [];
  files: File[] = [];

  @ViewChild(FileDragDropComponent, { static: false })
  private fileDragDrop: FileDragDropComponent;
  TOKEN = 'token';
  token: String;
  parsedJson: any;
  errorMsgId: number;
  fileName: string;
  auditProgramAIRItemAuditorDocumentList: AuditProgramAIRItemDocumentDTO[];
  auditProgramAIRItemAuditeeDocumentList: AuditProgramAIRItemDocumentDTO[];
  auditAirLogList: AuditAirLogBean[];
  auditProgramAIRDTO = new AuditProgramAIRDTO();
  //auditorDocumentCount: number = 0;
  //auditeeDocumentCount: number = 0;
  documentDTO: AuditProgramAIRItemDocumentDTO = new AuditProgramAIRItemDocumentDTO();
  airAuditorActionComboList: ComboPopulation[] = [];
  commonDTO = new CommonDTO();
  auditorAction: string;
  auditorRemarks: string;
  disabledActionButtos: boolean = false;
  uploadStart: boolean = false;
  @ViewChild('showErrorMessage', { static: true }) showErrorMessageId: ElementRef;

  @Input() auditProgramAIRItemDocumentDTO: AuditProgramAIRItemDocumentDTO;
  @Input() isDraftReportReleased: number;
  @Input() selectedIndex: number;
  //FORM COMMONAIR COMPONENT
  @Input() enableAllTransaction: string;

  @Output() refreshAIRList: EventEmitter<any> = new EventEmitter();
  @Output() closePanelAirAttachment: EventEmitter<any> = new EventEmitter();

  airItemAuditorActionForm = new FormGroup({
    auditorActionId: new FormControl('', Validators.required),
    remarks: new FormControl('', [Validators.required, Validators.maxLength(200)]),
  });

  airItemAuditorActionFormDefaultValues: any = {
    auditorActionId: '',
    remarks: '',
  };

  constructor(
    private http: HttpClient,
    public dialog: EasyDialog,
    private ts: TranslatePipe,
    private airMasterService: AirMasterService,
    private customMessage: CustomMessages,
    private sidebarComponent: SidebarComponent,
    private manageAuditProgarmService: ManageAuditProgarmService,
    private commonService: CommonService,
    private urlConfigService: UrlConfigService
  ) {
    this.ELEMENT_DATA1 = this.dummyData;
    this.dataSource1 = new MatTableDataSource(this.ELEMENT_DATA1);
  }

  ngOnInit() {
    this.auditorRemarks = this.auditProgramAIRItemDocumentDTO.auditorRemarks;
    this.auditorAction = this.auditProgramAIRItemDocumentDTO.auditorActionId;
    this.auditProgramAIRDTO.auditProgramId = this.auditProgramAIRItemDocumentDTO.auditProgramId;
    this.auditProgramAIRDTO.airTemplateId = '0';
    this.auditProgramAIRDTO.airDescription = '';
    this.auditProgramAIRDTO.siteId = this.auditProgramAIRItemDocumentDTO.siteId;
    this.auditProgramAIRDTO.departmentId = this.auditProgramAIRItemDocumentDTO.departmentId;
    this.auditProgramAIRDTO.sectionId = '0';
    this.auditProgramAIRDTO.statusId = '10';
    // this.auditProgramAIRDTO.auditorAction = this.auditProgramAIRItemDocumentDTO.auditorAction;
    this.getAuditAirLog();
    this.getAuditProgramAIRItemDocumentList('auditor');
    this.getAIRAuditorActionList();
    this.getAuditProgramAIRItemDocumentList('auditee');
    this.getAirAuditeeActionStandardRepoDocList('');

    // this.getStandardRepoDocListAudiorAIRdownload('');

    if (this.isDraftReportReleased == 0) {
      this.disabledActionButtos = false;
    } else {
      this.disabledActionButtos = true;
    }
  }

  uploadAuditProgramAIRItemDocument() {
    this.uploadStart = true;
    if (this.isDraftReportReleased == 1) {
      this.fileDragDrop.deleteAttachment(0);
      this.customMessage.showErrorMessage(
        'cams.label.common.actionAbortedDraftReportAlreadyReleased',
        ''
      );
      this.uploadStart = false;
      return false;
    }

    this.fileArray = this.fileDragDrop.selectedFiles;

    if (this.fileArray.length == 0) {
      this.customMessage.showErrorMessage('cams.label.common.mandatoryFileSelectionForUpload', '');
      this.uploadStart = false;
      return false;
    }

    if (this.fileArray.length > 1) {
      this.customMessage.showErrorMessage('cams.label.common.multipleFilesCannotBeDownloaded', '');
      this.uploadStart = false;
      return false;
    }

    let fileSize: number = this.fileArray[0].size;
    if (fileSize / (1024 * 1024) > this.maxUploadSizeInMb) {
      this.fileDragDrop.deleteAttachment(0);
      this.customMessage.showErrorMessage(
        'cams.label.common.fileSizeCannotBeGreaterThanDefinedMb',
        this.maxUploadSizeInMb + ' MB.'
      );
      this.uploadStart = false;
      return false;
    }

    const formData = new FormData();
    //let url = environment.SERVER_URL;
    let url = this.urlConfigService.apiServerUrl;
    let fileName;

    for (var i = 0; i < this.fileArray.length; i++) {
      formData.append('files', this.fileArray[i]);
    }

    formData.append('auditProgramId', this.auditProgramAIRItemDocumentDTO.auditProgramId);
    formData.append('airItemId', this.auditProgramAIRItemDocumentDTO.airItemId);

    $.ajax({
      url: url + 'auditProgram/air/uploadAIRItemDocument',
      type: 'POST',
      data: formData,
      dataType: 'text',
      mimeType: 'multipart/form-data;charset=UTF-8',
      processData: false,
      contentType: false,
      cache: false,
      headers: { Authorization: localStorage.getItem(this.TOKEN) },
      error: function(jqXHR, exception) {
        var jsonResponseText = $.parseJSON(jqXHR.responseText);
        $('#showErrorMessage').val(jsonResponseText.msgId);
        $('#showErrorMessage').click();
      },
      complete: function() {},
      success: function(res) {
        $('#showSuccessMessage').click();
      },
    });
  }

  getAuditProgramAIRItemDocumentList(userType) {
    if (userType == 'auditor') {
      this.auditProgramAIRItemDocumentDTO.isUploadedByAuditees = '0';
    } else {
      this.auditProgramAIRItemDocumentDTO.isUploadedByAuditees = '1';
    }

    this.auditProgramAIRItemDocumentDTO.actionType = 'L';
    this.sidebarComponent.showHideLoader(true);
    this.manageAuditProgarmService
      .getAuditProgramAIRItemDocumentList(this.auditProgramAIRItemDocumentDTO)
      .subscribe(
        data => {
          this.sidebarComponent.showHideLoader(false);
          this.parsedJson = JSON.parse(JSON.stringify(data));
          if (userType == 'auditor') {
            this.auditProgramAIRItemAuditorDocumentList = this.parsedJson;
            //this.auditorDocumentCount = this.auditProgramAIRItemAuditorDocumentList.length;
          } else if (userType == 'auditee') {
            this.auditProgramAIRItemAuditeeDocumentList = this.parsedJson;
            //this.auditeeDocumentCount = this.auditProgramAIRItemAuditeeDocumentList.length;
          }
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  getAuditAirLog() {
    this.manageAuditProgarmService
      .getAuditProgramAIRLog(this.auditProgramAIRItemDocumentDTO)
      .subscribe(
        data => {
          this.sidebarComponent.showHideLoader(false);
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.auditAirLogList = this.parsedJson;
          this.ELEMENT_DATA = this.auditAirLogList;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  /* ----------------------------Start Delete AIR Document --------------------------------- */

  airDocumentDisplayMessage() {
    if (this.isDraftReportReleased == 1) {
      this.customMessage.showErrorMessage(
        'cams.label.common.actionAbortedDraftReportAlreadyReleased',
        ''
      );
      return false;
    } else {
      let obj = this;
      obj.dialog.confirm(
        obj.ts.transform('cams.label.common.confirm'),
        obj.ts.transform('cams.label.common.confirmationToDeleteAuditProgramAirDocument'),
        async function() {
          obj.deleteAIRDocument();
        },
        function() {}
      );
    }
  }

  showDeleteAIRDocumentConfirmation(item: AuditProgramAIRItemDocumentDTO) {
    this.documentDTO.documentId = item.documentId;
    this.airDocumentDisplayMessage();
  }

  deleteAIRDocument() {
    this.documentDTO.actionType = 'D';
    this.documentDTO.airItemId = this.auditProgramAIRItemDocumentDTO.airItemId;
    this.documentDTO.auditProgramId = this.auditProgramAIRItemDocumentDTO.auditProgramId;
    this.manageAuditProgarmService
      .deleteAuditProgramAIRItemDocumentByDocumentId(this.documentDTO)
      .subscribe(
        data => {
          this.showSuccessMessage();
          this.parsedJson = JSON.parse(JSON.stringify(data));
        },
        error => {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  /* ----------------------------End Delette AIR Document --------------------------------- */

  /* ----------------------------Start Download AIR Document --------------------------------- */
  downloadAIRDocument(item: AuditProgramAIRItemDocumentDTO) {
    this.sidebarComponent.showHideLoader(true);
    this.documentDTO.documentId = item.documentId;
    this.manageAuditProgarmService.downloadAuditProgramAIRItemDocument(this.documentDTO).subscribe(
      (data: any) => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = item.fileName;
        link.click();
        this.sidebarComponent.showHideLoader(false);
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        if (error.error.msgId == undefined || error.error.msgId == '') {
          error.error.msgId = 'cams.label.common.errorOccuredInOperation';
          this.customMessage.showErrorMessage(error.error.msgId, '');
        } else {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      }
    );
  }

  /* ----------------------------End Download AIR Document --------------------------------- */

  showSuccessMessage() {
    this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
    this.uploadStart = false;
    this.refreshData();
    this.fileDragDrop.deleteAttachment(0);
    this.getAuditProgramAIRItemDocumentList('auditor');
  }

  showErrorMessage() {
    this.fileDragDrop.deleteAttachment(0);

    if ($('#showErrorMessage').val() == 'cams.label.common.file.extn.not.allowed') {
      this.customMessage.showErrorMessage(
        $('#showErrorMessage').val(),
        this.fileExtnNotAllowedToUpload
      );
    } else {
      this.customMessage.showErrorMessage($('#showErrorMessage').val(), '');
    }
    this.uploadStart = false;
  }

  validateFile(name: String) {
    let ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'xls' || ext.toLowerCase() == 'xlsx') {
      return true;
    } else {
      return false;
    }
  }

  /* ----------------------------Start Auditor Action --------------------------------- */
  getAIRAuditorActionList() {
    this.sidebarComponent.showHideLoader(true);
    this.commonService.getAIRAuditorActionList().subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.airAuditorActionComboList = this.parsedJson;
        this.sidebarComponent.showHideLoader(false);
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  saveAirItemAuditorActionConfirmationOfUpload() {
    if (this.isDraftReportReleased == 1) {
      this.customMessage.showErrorMessage(
        'cams.label.common.actionAbortedDraftReportAlreadyReleased',
        ''
      );
      return false;
    }

    if (this.auditProgramAIRItemDocumentDTO.auditeeAction == 'No Action') {
      this.customMessage.showErrorMessage(
        'cams.message.common.action.pending.from.auditee.side',
        ''
      );
      return false;
    }

    let message;
    if (this.airItemAuditorActionForm.status == 'INVALID') {
      if (this.airItemAuditorActionForm.get('auditorActionId').invalid) {
        if (this.airItemAuditorActionForm.get('auditorActionId').errors.required) {
          this.customMessage.showErrorMessage('cams.label.addAirItems.mandatoryAuditorAction', '');
          return false;
        }
      }

      if (this.airItemAuditorActionForm.get('remarks').invalid) {
        if (this.airItemAuditorActionForm.get('remarks').errors.required) {
          this.customMessage.showErrorMessage('cams.label.common.mandatoryRemarks', '');
          return false;
        }

        if (this.airItemAuditorActionForm.get('remarks').hasError('maxLength')) {
          this.customMessage.showErrorMessage('cams.label.common.remarksMaxLength200', '');
          return false;
        }
      }
    }

    if (this.fileDragDrop != undefined && this.fileDragDrop.selectedFiles.length > 0) {
      let obj = this;
      obj.dialog.confirm(
        obj.ts.transform('cams.label.common.confirm'),
        obj.ts.transform('cams.label.common.confirmationToUploadFile'),
        async function() {
          obj.uploadAuditProgramAIRItemDocument();
          obj.saveAirItemAuditorAction('');
          //dialogRef.disableClose = true;
        },
        function() {
          obj.saveAirItemAuditorAction('');
          //ACTION: Do this if user says NO
          //that.name = "No clicked";
        }
      );
    } else {
      this.saveAirItemAuditorAction('');
    }
  }
  saveAirItemAuditorAction(actionType: string) {
    this.commonDTO.airItemId = this.auditProgramAIRItemDocumentDTO.airItemId;
    this.commonDTO.auditorAction = this.airItemAuditorActionForm.get('auditorActionId').value;
    this.commonDTO.remarks = this.airItemAuditorActionForm.get('remarks').value;
    this.sidebarComponent.showHideLoader(true);

    this.commonService.saveAIRItemAuditorAction(this.commonDTO).subscribe(
      data => {
        //this.refreshData();
        this.sidebarComponent.showHideLoader(false);
        this.fileDragDrop.deleteAttachment(0);

        this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');

        this.closed();
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  /* ----------------------------End Auditor Action --------------------------------- */

  refreshData() {
    //this.refreshAIRList.emit(this.auditProgramAIRDTO);
  }

  closed() {
    if (this.fileDragDrop != undefined && this.fileDragDrop.selectedFiles.length > 0) {
      let obj = this;
      obj.dialog.confirm(
        obj.ts.transform('cams.label.common.confirm'),
        obj.ts.transform('cams.label.common.confirmationToUploadFile'),
        async function() {
          obj.uploadAuditProgramAIRItemDocument();
        },
        function() {
          obj.closePanelAirAttachment.emit(obj.auditProgramAIRDTO);
          obj.fileDragDrop.deleteAttachment(0);
          obj.fileDragDrop.selectedFiles = [];
          obj.fileDragDrop.files = [];
          obj.airItemAuditorActionForm.reset(obj.airItemAuditorActionFormDefaultValues);

          obj.auditProgramAIRItemAuditorDocumentList = [];
          //obj.auditorDocumentCount = 0;
          obj.auditProgramAIRItemAuditeeDocumentList = [];
          //obj.auditeeDocumentCount = 0;
        }
      );
    } else {
      this.closePanelAirAttachment.emit(this.auditProgramAIRDTO);
      this.fileDragDrop.selectedFiles = [];
      this.fileDragDrop.files = [];
      this.fileDragDrop.deleteAttachment(0);
      this.airItemAuditorActionForm.reset(this.airItemAuditorActionFormDefaultValues);

      this.auditProgramAIRItemAuditorDocumentList = [];
      //this.auditorDocumentCount = 0;
      this.auditProgramAIRItemAuditeeDocumentList = [];
      //this.auditeeDocumentCount = 0;
    }
  }

  // -------------------------StandardRepoDocAudiorAIRSCREEN Displaying List Code -----------------------------------
  getAirAuditeeActionStandardRepoDocList(siteId: string) {
    this.auditProgramAIRDTO.siteId = this.auditProgramAIRItemDocumentDTO.siteId;
    this.auditProgramAIRDTO.airItemId = this.auditProgramAIRItemDocumentDTO.airItemId;

    this.manageAuditProgarmService
      .getAirAuditeeActionStandardRepoDocList(this.auditProgramAIRDTO)
      .subscribe(
        data => {
          this.sidebarComponent.showHideLoader(false);
          this.parsedJson1 = JSON.parse(JSON.stringify(data));

          this.airaAditeeActioncStandardRepoList = this.parsedJson1;

          this.ELEMENT_DATA1 = this.airaAditeeActioncStandardRepoList;

          this.dataSource1 = new MatTableDataSource(this.ELEMENT_DATA1);
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  getStandardRepoDocListAudiorAIRdownload(documentId: any, filePath: any, document_Type: any) {
    this.auditProgramAIRDTO.siteId = this.auditProgramAIRItemDocumentDTO.siteId;
    this.auditProgramAIRDTO.airItemId = this.auditProgramAIRItemDocumentDTO.airItemId;
    this.auditProgramAIRDTO.filePath = filePath;

    //const a = ele;
    this.auditProgramAIRDTO.documentId = documentId;

    this.manageAuditProgarmService
      .getStandardRepoDocListAudiorAIRdownload(this.auditProgramAIRDTO)
      .subscribe(
        (data: any) => {
          this.parsedJson1 = JSON.parse(JSON.stringify(data));
          this.downloadDataList = this.parsedJson1;
          var downloadURL = window.URL.createObjectURL(data);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = document_Type;
          link.click();
          this.sidebarComponent.showHideLoader(false);
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          if (error.error.msgId == undefined || error.error.msgId == '') {
            error.error.msgId = 'cams.label.common.errorOccuredInOperation';
            this.customMessage.showErrorMessage(error.error.msgId, '');
          } else {
            this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
          }
        }
      );
  }
}
